export const SET_COLLECTIONS = 'users/SET_COLLECTIONS';
export const SET_COLLECTION = 'users/SET_COLLECTION';
export const SET_BY_ID = 'users/SET_BY_ID';
